import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as yup from 'yup';

import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { IGameScreen } from '@/interface/game';
import { IGameLeadInput } from '@/interface/gameLead';
import { getUserUuid } from '@/util/uuid';
import { validateMobileNumber } from '@/util/game';
import LeadInfoInputPreview from '../../Canvas/Elements/Input/LeadInfoInputPreview';
import { jsonParse } from '@/util/stringify';
import ElementsPreview from '../../Canvas/Elements/ElementsPreview';
import { gameUserInfoCreateAction } from '@/redux/action/gameUserInfo';

// eslint-disable-next-line no-useless-escape
const phoneRegExp = /^\+?[0-9]*[ \(\)-]*[0-9]*$/;

const schema = yup.object().shape({
  mobile_number: yup.string().matches(phoneRegExp, 'Mobile No. is not valid'),
  email: yup.string().email(),
});

const LeadForm = ({ data, gameId, score, onClose }: LeadFormProps) => {
  const [isTandCChecked, setIsTandCChecked] = useState<boolean>(false);
  const [requiredFields, setRequiredFields] = useState<any>();
  const [coutryCode, setCountryCode] = useState<string | undefined>(undefined);
  const { isGameLeadSubmitPending } = useAppSelector(state => state.game);
  const dispatch = useAppDispatch();

  const onSubmit = async (data: IGameLeadInput) => {
    const uid = await getUserUuid();

    data.uid = uid;

    dispatch(
      gameUserInfoCreateAction(data, () => {
        onClose && onClose(data);
      })
    );
  };
  const onTandCChecked = () => {
    setIsTandCChecked(!isTandCChecked);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {},
    validationSchema: schema,

    onSubmit: (val: any) => {
      val.game = gameId;
      if (data?.position !== 'START') {
        val.score = score;
      }
      const body = { ...val };
      if ('pin_code' in body) {
        delete body['pin_code'];
      }
      if ('privacy_policy' in body) {
        delete body['privacy_policy'];
      }
      if (isGameLeadSubmitPending) return;
      onSubmit(body);
    },
    validate: (val: any) => {
      const errors: any = {};
      requiredFields?.forEach((ele: any) => {
        if (!val[ele.name]) {
          let prefix = ele.label;
          switch (ele.name) {
            case 'mobile_number':
              prefix = 'Mobile Number';
              break;
            case 'feedback':
              prefix = 'Feedback';
              break;
            default:
              prefix = ele.label;
          }
          let erMsg = `${prefix} is required`;
          erMsg =
            erMsg === 'Prénom is required' ? 'Information requise' : erMsg;
          errors[ele.name] = erMsg;
        }
      });
      if (val.mobile_number && coutryCode) {
        const isValidNumber = validateMobileNumber(
          val.mobile_number,
          coutryCode
        );
        if (!isValidNumber) errors.mobile_number = 'Invalid Mobile Number';
      }

      return errors;
    },
  });
  const { errors, values } = formik;

  useEffect(() => {
    if (data) {
      setRequiredFields(
        data?.user_info?.filter(
          ele => ele.is_required && ele.type !== 'termsAndCondition'
        )
      );
      data?.user_info?.forEach(ele => {
        formik.setFieldValue(ele.name, undefined);
        if (ele.name === 'mobile_number' && ele.country_code) {
          setCountryCode(ele.country_code);
        }
      });
    }
  }, [data]);
  useEffect(() => {
    if (data?.user_info && data?.user_info.length > 0) {
      const hasTandC = data?.user_info.find(
        ele => ele.name === 'termsAndCondition'
      );
      if (!hasTandC) {
        setIsTandCChecked(true);
      }
    }
  }, []);
  return (
    <>
      <form className="" onSubmit={formik.handleSubmit}>
        {data?.user_info &&
          data?.user_info?.map((ele, i) => (
            <LeadInfoInputPreview
              placeholder={ele.label}
              element={jsonParse(ele?.style)}
              name={ele.name}
              label={ele.label}
              countryCode={ele.country_code}
              termsAndConditionUrl={ele.tandc_uri}
              onChange={formik.handleChange}
              setFieldValue={formik.setFieldValue}
              type={ele.type}
              value={values[ele.name as keyof typeof formik.values]}
              key={i}
              error={errors[ele.name]}
              isTandCChecked={isTandCChecked}
              onTandCChecked={onTandCChecked}
            />
          ))}
        <ElementsPreview elements={data?.elements} />
      </form>
    </>
  );
};

type LeadFormProps = {
  data?: IGameScreen;
  gameId?: string;
  score?: number;
  onClose?: (a?: IGameLeadInput) => void;
};
export default LeadForm;
